/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Target_Group_LabelInputs */

const en_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Group`)
};

const fr_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe cible`)
};

const de_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe`)
};

const it_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo target`)
};

const ru_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая группа`)
};

const es_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo objetivo`)
};

const zh_cn2_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标群体`)
};

const ja_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象グループ`)
};

const hi_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्षित समूह`)
};

const pt_pt2_translation_merge_target_group_label = /** @type {(inputs: Translation_Merge_Target_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público-alvo`)
};

/**
* | output |
* | --- |
* | "Target Group" |
*
* @param {Translation_Merge_Target_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_target_group_label = /** @type {((inputs?: Translation_Merge_Target_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Target_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_target_group_label(inputs)
	if (locale === "de") return de_translation_merge_target_group_label(inputs)
	if (locale === "it") return it_translation_merge_target_group_label(inputs)
	if (locale === "ru") return ru_translation_merge_target_group_label(inputs)
	if (locale === "es") return es_translation_merge_target_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_target_group_label(inputs)
	if (locale === "ja") return ja_translation_merge_target_group_label(inputs)
	if (locale === "hi") return hi_translation_merge_target_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_target_group_label(inputs)
	return en_translation_merge_target_group_label(inputs)
});